import {
  formatNumberToCompact,
  formatNumberWithPoints,
} from '@/utils/helpers.ts'

export const formatRangeSliderThumbValue = (number: number) => {
  if (number < 1000000) {
    return formatNumberWithPoints(number)
  }

  return formatNumberToCompact(number)
}

export const getRawNumber = (number: string) => {
  return parseInt(number.replace(/\./g, ''))
}
